import "./StepIndicator.scss"

interface StepIndicatorProps {
  currentStep: number
}

const STEPS = [
  { number: 1, label: "Define Scheduler Basics" },
  { number: 2, label: "Set Scheduler Design" },
  { number: 3, label: "Review and Confirm" }
]

function StepIndicator(props: StepIndicatorProps) {
  return (
    <div className="step-indicator">
      {STEPS.map((step, index) => (
        <div key={step.number} className="step-indicator__item">
          <div className="step-indicator__step">
            <div
              className={`step-indicator__circle ${
                step.number <= props.currentStep ? "step-indicator__circle--active" : ""
              }`}
            >
              {step.number}
            </div>
            {index < STEPS.length - 1 && (
              <div
                className={`step-indicator__line ${
                  step.number < props.currentStep ? "step-indicator__line--active" : ""
                }`}
              />
            )}
          </div>
          <div className="step-indicator__label">{step.label}</div>
        </div>
      ))}
    </div>
  )
}

export default StepIndicator
